/**
 * Badge presentation for a profile's login platform, derived from the `platform`
 * key on their `login` audit events. Null means no login event on record.
 */
export type LoginPlatform = 'web' | 'mobile' | 'ios' | 'android' | 'unknown';

export interface LoginPlatformBadge {
  icon: string;
  badge: string;
}

export function getLoginPlatformBadge(platform: LoginPlatform | null): LoginPlatformBadge {
  let rawIcon: string;
  let rawBadge: string;

  switch (platform) {
    case 'web':
      rawIcon = 'laptop';
      rawBadge = 'bg-primary text-light';
      break;
    case 'ios':
      rawIcon = 'apple';
      rawBadge = 'bg-secondary';
      break;
    case 'android':
      rawIcon = 'android2';
      rawBadge = 'bg-success';
      break;
    case 'mobile':
      rawIcon = 'phone';
      rawBadge = 'bg-info';
      break;
    default:
      // Covers 'unknown' and null.
      rawIcon = 'question';
      rawBadge = 'bg-light text-dark';
  }

  return { icon: `bi bi-${rawIcon}`, badge: `badge ${rawBadge}` };
}
